const normalizeParentThreadId = (value) => {
  const normalized = String(value || '').trim();
  return normalized || null;
};

export default normalizeParentThreadId;
